export default "__VITE_ASSET__3203f9d1__"